import React, { useLayoutEffect, useReducer } from 'react';
import { SafeAreaView, StyleSheet, Text, View } from 'react-native';
import { Color, CommonProperties, CommonStyles } from '../../../styles';
import { AvatarActionTypes } from '../../TripHub/Traveler/AvatarTraveler';
import TravelerList from '../../TripHub/Traveler/TravelerList';
import produce from 'immer';
import { FlatList, TouchableOpacity } from 'react-native-gesture-handler';
import TravelerItem from '../../TripHub/Social/TravelerItem';
import BaseText from '../../BaseText';
import { HeaderButtons } from 'react-navigation-header-buttons';
import { useNavigation } from '@react-navigation/core';
import { Modals } from '../../../constants/ScreenNames';
import WrapBottomColor from '../../containers/WrapBottomColor';
import BottomButton from '../../BottomButton';

const initialState = {
  selectedUsers: [],
  users: [
    { id: 0, name: 'April A.', desc: 'Connection', checked: false },
    { id: 1, name: 'April B.', desc: 'Connection', checked: false },
    { id: 2, name: 'April C.', desc: 'Connection', checked: false },
    { id: 3, name: 'April D.', desc: 'Connection', checked: false },
    { id: 4, name: 'April E.', desc: 'Connection', checked: false },
    { id: 5, name: 'April F.', desc: 'Connection', checked: false },
    { id: 6, name: 'April G.', desc: 'Connection', checked: false },
    { id: 7, name: 'April I.', desc: 'Connection', checked: false },
  ],
};

const TOGGLE_USER = 'TOGGLE_USER';
const reducer = (state, action) => {
  switch (action.type) {
    case TOGGLE_USER:
      return produce(state, (draft) => {
        const { id } = action?.payload;

        const indexUser = state.users.findIndex((i) => id === i.id);

        draft.users[indexUser].checked = !state.users[indexUser].checked;
        const indexSelectedUser = state.selectedUsers.findIndex((i) => id === i.id);
        if (indexSelectedUser === -1) {
          draft.selectedUsers.push(state.users[indexUser]);
        } else {
          draft.selectedUsers = state.selectedUsers.filter((a) => a.id !== id);
        }
      });
    default:
      return state;
  }
};

const InvitationTravelerModal = () => {
  const navigation = useNavigation();
  const [{ users, selectedUsers }, dispatch] = useReducer(reducer, initialState);

  useLayoutEffect(() => {
    navigation.setOptions({
      headerTitle: () => <BaseText style={CommonStyles.h3}>Create a Group</BaseText>,
      headerRight: () => (
        <TouchableOpacity onPress={() => navigation.navigate(Modals.InvitePermissionsModal)}>
          <BaseText
            style={{ color: Color.primary, ...CommonProperties.p3, ...CommonProperties.h2 }}
          >
            Skip
          </BaseText>
        </TouchableOpacity>
      ),
      headerTitleAlign: 'center',
    });
  }, [navigation]);

  return (
    <WrapBottomColor style={styles.container}>
      <View style={styles.inner}>
        <Text style={styles.title}>Invite travelers</Text>
        {selectedUsers.length > 0 ? (
          <View>
            <BaseText style={styles.invitedTitle}>{`Invited (${selectedUsers.length})`}</BaseText>
            <TravelerList
              list={selectedUsers}
              avatarActionType={AvatarActionTypes.CANCEL}
              onPress={(item) => {
                dispatch({
                  type: TOGGLE_USER,
                  payload: { id: item.id },
                });
              }}
            />
          </View>
        ) : null}
        <FlatList
          data={users}
          keyExtractor={(item) => item.id}
          renderItem={({ item }) => (
            <TravelerItem
              item={item}
              onPress={() => dispatch({ type: TOGGLE_USER, payload: { id: item.id } })}
            />
          )}
        />
      </View>
      <BottomButton
        label="Invite"
        full
        onPress={(e) => {
          e.preventDefault();
          navigation.navigate(Modals.InvitePermissionsModal);
        }}
      />
    </WrapBottomColor>
  );
};

const styles = StyleSheet.create({
  title: {
    ...CommonProperties.h2,
    ...CommonProperties.px3,
  },
  invitedTitle: {
    ...CommonProperties.px3,
    ...CommonProperties.py1,
    ...CommonProperties.h3,
  },
  container: {
    flex: 1,
    backgroundColor: 'white',
    //...CommonProperties.p3,
  },
  inner: {
    flex: 1,
    ...CommonProperties.py3,
  },
});

export default InvitationTravelerModal;
